export const sessionStorageKeys = {
  INVOICE_ACTIVE_TAB: 'invoice_active_tab',
  COMPANY_ACTIVE_TAB: 'company_active_tab',
  OVERVIEW_FILTER: 'overview_filter_',
  TABLE_COL_FILTER: 'table_col_filter_',
};
